export const fetchPostcode = async (postcode) => {
  // 未入力の場合はnull返却
  if (!postcode) return null;

  // ハイフンとる
  postcode = postcode.replace("-", "");
  // 未入力の場合はnull返却
  if (!(postcode.match(/[0-9]/) && postcode.length === 7)) {
    return null;
  }

  const result = await fetch(
    `https://postcode.teraren.com/postcodes/${postcode}.json`
  )
    .then((res) => res.json())
    .catch((err) => console.log(err));

  return result;
};
